import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils copy/@reduxjs/toolkit';
import { MealsServingState, MealsServingInterface, ActivityEnum } from '../types';
import { set } from 'lodash';

export const initialState: MealsServingState = {
  loading: false,
  isadd: false,
  pageNo: 1,
  pageSize: 10,
  totalRow: 0,
  search: '',
  list: [],
  form: {
    _id: '',
    id: '',
    minAge: 0,
    maxAge: 4,
    noOfServings: 0,
    isActive: ActivityEnum.YES
  },
  sortColumn: '',
  sortDir: '',
  listAll: []
};

export const useClinicSlice = createSlice({
  name: 'mealsServingState',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    updateFormValue: (state, action: PayloadAction<{ key: string; value: any }>) => {
      set(state, `form.${action.payload.key}`, action.payload.value);
    },
    clearForm: (state) => {
      state.form._id = '';
      state.form.id = '';
      state.form.minAge = 0;
      state.form.maxAge = 4;
      state.form.noOfServings = 0;
      state.form.isActive = ActivityEnum.YES;
    },
    doAdd: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doGetList: (state) => {},
    doGetEdit: (state, action: PayloadAction<string>) => {},
    doUpdate: (state, action: PayloadAction<{ callback: () => void }>) => {},

    setList: (state, action: PayloadAction<Array<MealsServingInterface>>) => {
      state.list = action.payload;
    },
    setSortColumn: (state, action: PayloadAction<string>) => {
      state.sortColumn = action.payload;
    },
    setSortDir: (state, action: PayloadAction<string>) => {
      state.sortDir = action.payload;
    },
    setDataForEdit: (state, action: PayloadAction<MealsServingInterface>) => {
      state.form = action.payload;
    },
    doGetAllList: (state) => {},
    setAllList: (state, action: PayloadAction<Array<MealsServingInterface>>) => {
      state.listAll = action.payload;
    }
  }
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
